/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clause: NonNullable<unknown> }} Filter_Chip_EditInputs */

const en_filter_chip_edit = /** @type {(inputs: Filter_Chip_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change filter ${i?.clause}`)
};

const de_filter_chip_edit = /** @type {(inputs: Filter_Chip_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filter ${i?.clause} ändern`)
};

/**
* | output |
* | --- |
* | "Change filter {clause}" |
*
* @param {Filter_Chip_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_chip_edit = /** @type {((inputs: Filter_Chip_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Chip_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_chip_edit(inputs)
	return en_filter_chip_edit(inputs)
});